import { render, staticRenderFns } from "./AbcAnalysis.vue?vue&type=template&id=3063a85a&scoped=true&"
import script from "./AbcAnalysis.vue?vue&type=script&lang=js&"
export * from "./AbcAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./AbcAnalysis.vue?vue&type=style&index=0&id=3063a85a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3063a85a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VDataTable})
